const MAIN_LINK =
  'https://ideas-que-transforman-2.myshopify.com/products/no-sabes-como-empezar-a-generar-ingresos-y-eso-te-esta-frenando'

export function getCheckoutUrl(addedBumps: Record<string, boolean>): string {
  const hasIA = !!addedBumps['ia']
  const hasMensajes = !!addedBumps['mensajes']
  const hasClientes = !!addedBumps['clientes']

  // All three bumps
  if (hasIA && hasMensajes && hasClientes) {
    return 'https://ideas-que-transforman-2.myshopify.com/cart/53245012246871:1'
  }

  // Two bumps
  if (hasIA && hasMensajes) {
    return 'https://ideas-que-transforman-2.myshopify.com/cart/53177865601367:1'
  }
  if (hasIA && hasClientes) {
    return 'https://ideas-que-transforman-2.myshopify.com/cart/53245012672855:1'
  }
  if (hasMensajes && hasClientes) {
    return 'https://ideas-que-transforman-2.myshopify.com/cart/53245060645207:1'
  }

  // Single bump
  if (hasIA) {
    return 'https://ideas-que-transforman-2.myshopify.com/cart/53177846923607:1'
  }
  if (hasMensajes) {
    return 'https://ideas-que-transforman-2.myshopify.com/cart/53177923633495:1'
  }
  if (hasClientes) {
    return 'https://ideas-que-transforman-2.myshopify.com/cart/53245011362135:1'
  }

  return MAIN_LINK
}
